import styled, { css } from "styled-components";
import { color, space } from "styled-system";
import { Box } from "grid-styled";

const common = css`
  margin-bottom: 1rem;
  margin-top: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.primary};
  ${color};
  ${space};
`;

export const H1 = styled.h1`
  ${common};

  color: ${({ theme }) => theme.secondary};
  font-weight: 700;
  font-size: 80px;
  line-height: 70px;
  ${color};
`;

export const H2 = styled.h2`
  ${common};
  font-weight: 700;
  color: ${({ theme }) => theme.primary};
  font-size: 44px;
  line-height: 46px;
  ${color};
`;

export const H3 = styled.h3`
  ${common};
  font-weight: 700;
  font-size: 32px;
  line-height: 32px;
`;

export const H4 = styled.h4`
  ${common};
`;

export const H5 = styled.h5`
  ${common};
`;

export const H6 = styled.h6`
  ${common};
`;

export const Body = styled(Box)`
  font-weight: 400;
  font-size: 21px;
  line-height: 30px;
  color: ${({ theme }) => theme.secondary};
  ${color};
`;

export const SmallBody = styled(Box)`
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: ${({ theme }) => theme.secondary};
  ${color};
`;

export const DescriptionText = styled(Box)`
  color: white
  font-size: 14px;
  line-height: 24px;
`;
